import { render, staticRenderFns } from "./field-message.vue?vue&type=template&id=8ea887b0&"
import script from "./field-message.vue?vue&type=script&lang=js&"
export * from "./field-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports